var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_vm._m(0),_vm._m(1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" 经营范围： 文化艺术交流策划；企业形象策划；设计、制作、发布、代理各类广告；"),_c('br'),_vm._v(" 礼仪服务；展览展示服务；会务服务；计算机软件开发；"),_c('br'),_vm._v(" 从事计算机软件科技领域内的技术开发、技术服务、技术咨询、技术转让。 ")])
},function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bottom"},[_vm._v("Copyright © 2022 上海乐狮文化传播有限公司 "),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/"}},[_vm._v("沪ICP备17024901号-1")])])
}]

export { render, staticRenderFns }